import React, { Component } from "react";
import {
  loading,
  NavbarAdmin,
  t, // นำเข้าฟังก์ชัน t
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js";

export default class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
        // Sidebar Active Tab
        active_tab: "company_profile",

        // Mock Data: Company Profile
        company_name: "Global Utilities Services Co., Ltd.",
        tax_id: "0105543036026",
        address: "6th Floor, 540 Mercury Tower, Phloenchit Road, Lumphini, Pathumwan, Bangkok 10330",
        phone: "(662) 658-6299",
        email: "info@gusco.co.th",

        // Mock Data: Notification Settings
        notify_new_request: true,
        notify_sla_warning: true,
        notify_job_completion: true,
        notify_daily_summary: false,
    };
  }

  async componentDidMount() {
    loading(false);
  }

  render() {
    const { 
      active_tab, company_name, tax_id, address, phone, email,
      notify_new_request, notify_sla_warning, notify_job_completion, notify_daily_summary
    } = this.state;

    // ย้าย sla_data มาไว้ใน render เพื่อให้ฟังก์ชัน t() สามารถทำงานและอัปเดตภาษาได้ทันที
    const sla_data = [
      { priority: t("emergency"), priorityColor: "danger", response: t("1_hour"), resolution: t("4_hours") },
      { priority: t("high"), priorityColor: "warning", response: t("4_hours"), resolution: t("24_hours") },
      { priority: t("medium"), priorityColor: "warning", response: t("8_hours"), resolution: t("48_hours"), isYellow: true },
      { priority: t("low"), priorityColor: "primary", response: t("24_hours"), resolution: t("72_hours") }
    ];

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          
          {/* Header Section */}
          <div className="mb-4">
            <h3 className="fw-bold mb-1 text-dark">{t("system_settings")}</h3>
            <div className="text-secondary text-14">{t("system_settings_desc")}</div>
          </div>

          <div className="row g-4">
            
            {/* Left Sidebar Menu */}
            <div className="col-lg-3">
              <div className="bg-white rounded-4 shadow-sm p-3 h-100">
                <h6 className="fw-bold text-dark mb-3 px-2 pt-2">{t("settings")}</h6>
                
                <div className="d-flex flex-column gap-1">
                  <div 
                    className={`d-flex align-items-center p-3 rounded-3 pointer transition-hover ${active_tab === 'company_profile' ? 'bg-primary-light text-primary fw-bold' : 'text-secondary hover-bg-light'}`}
                    onClick={() => this.setState({ active_tab: 'company_profile' })}
                  >
                    <span className="icon me-3 text-16 wpx-20 text-center">{"\uf2c1"}</span> {t("company_profile")}
                  </div>
                  
                  <div 
                    className={`d-flex align-items-center p-3 rounded-3 pointer transition-hover ${active_tab === 'sla' ? 'bg-primary-light text-primary fw-bold' : 'text-secondary hover-bg-light'}`}
                    onClick={() => this.setState({ active_tab: 'sla' })}
                  >
                    <span className="icon me-3 text-16 wpx-20 text-center">{"\uf017"}</span> {t("sla_configuration")}
                  </div>

                  <div 
                    className={`d-flex align-items-center p-3 rounded-3 pointer transition-hover ${active_tab === 'notifications' ? 'bg-primary-light text-primary fw-bold' : 'text-secondary hover-bg-light'}`}
                    onClick={() => this.setState({ active_tab: 'notifications' })}
                  >
                    <span className="icon me-3 text-16 wpx-20 text-center">{"\uf0f3"}</span> {t("notifications")}
                  </div>

                  <div 
                    className={`d-flex align-items-center p-3 rounded-3 pointer transition-hover ${active_tab === 'categories' ? 'bg-primary-light text-primary fw-bold' : 'text-secondary hover-bg-light'}`}
                    onClick={() => this.setState({ active_tab: 'categories' })}
                  >
                    <span className="icon me-3 text-16 wpx-20 text-center">{"\uf02b"}</span> {t("categories")}
                  </div>

                  <div 
                    className={`d-flex align-items-center p-3 rounded-3 pointer transition-hover ${active_tab === 'status_priority' ? 'bg-primary-light text-primary fw-bold' : 'text-secondary hover-bg-light'}`}
                    onClick={() => this.setState({ active_tab: 'status_priority' })}
                  >
                    <span className="icon me-3 text-16 wpx-20 text-center">{"\uf0cb"}</span> {t("status_priority")}
                  </div>

                  <div 
                    className={`d-flex align-items-center p-3 rounded-3 pointer transition-hover ${active_tab === 'user_roles' ? 'bg-primary-light text-primary fw-bold' : 'text-secondary hover-bg-light'}`}
                    onClick={() => this.setState({ active_tab: 'user_roles' })}
                  >
                    <span className="icon me-3 text-16 wpx-20 text-center">{"\uf505"}</span> {t("user_roles")}
                  </div>

                  <div 
                    className={`d-flex align-items-center p-3 rounded-3 pointer transition-hover ${active_tab === 'integrations' ? 'bg-primary-light text-primary fw-bold' : 'text-secondary hover-bg-light'}`}
                    onClick={() => this.setState({ active_tab: 'integrations' })}
                  >
                    <span className="icon me-3 text-16 wpx-20 text-center">{"\uf1e6"}</span> {t("integrations")}
                  </div>
                </div>
              </div>
            </div>

            {/* Right Content Area */}
            <div className="col-lg-9">
              <div className="d-flex flex-column gap-4">
                
                {/* 1. Company Profile Card */}
                <div className="card border-0 rounded-4 shadow-sm p-4 bg-white">
                  <h5 className="fw-bold text-dark mb-4">{t("company_profile")}</h5>
                  <div className="row g-4">
                    <div className="col-md-6">
                      <label className="form-label text-14 text-secondary mb-2">{t("company_name")}</label>
                      <input 
                        type="text" 
                        className="form-control py-2 text-dark fw-bold border-light" 
                        value={company_name}
                        onChange={(e) => this.setState({ company_name: e.target.value })}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label text-14 text-secondary mb-2">{t("tax_id")}</label>
                      <input 
                        type="text" 
                        className="form-control py-2 text-dark fw-bold border-light" 
                        value={tax_id}
                        onChange={(e) => this.setState({ tax_id: e.target.value })}
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label text-14 text-secondary mb-2">{t("address")}</label>
                      <textarea 
                        className="form-control py-2 text-dark fw-bold border-light" 
                        rows="2"
                        value={address}
                        onChange={(e) => this.setState({ address: e.target.value })}
                      ></textarea>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label text-14 text-secondary mb-2">{t("phone")}</label>
                      <input 
                        type="text" 
                        className="form-control py-2 text-dark fw-bold border-light" 
                        value={phone}
                        onChange={(e) => this.setState({ phone: e.target.value })}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label text-14 text-secondary mb-2">{t("email")}</label>
                      <input 
                        type="email" 
                        className="form-control py-2 text-dark fw-bold border-light" 
                        value={email}
                        onChange={(e) => this.setState({ email: e.target.value })}
                      />
                    </div>
                  </div>
                </div>

                {/* 2. SLA Configuration Card */}
                <div className="card border-0 rounded-4 shadow-sm p-4 bg-white">
                  <h5 className="fw-bold text-dark mb-1">{t("sla_configuration")}</h5>
                  <div className="text-secondary text-14 mb-4">{t("sla_desc")}</div>
                  
                  <div className="table-responsive">
                    <table className="table align-middle mb-0">
                      <thead>
                        <tr className="text-dark fw-bold text-12 border-bottom border-light">
                          <th className="py-3 border-0 wpx-200">{t("priority")}</th>
                          <th className="py-3 border-0">{t("response_time")}</th>
                          <th className="py-3 border-0">{t("resolution_time")}</th>
                          <th className="py-3 border-0 text-center wpx-100">{t("actions")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sla_data.map((item, idx) => (
                          <tr key={idx} className="border-bottom border-light">
                            <td className="py-3">
                              <span 
                                className={`badge rounded-pill fw-bold px-3 py-1 text-10 border ${item.isYellow ? 'bg-warning-light text-warning border-warning' : `bg-${item.priorityColor}-light text-${item.priorityColor} border-${item.priorityColor}`}`}
                                style={item.isYellow ? { color: '#d97706' } : {}}
                              >
                                {item.priority}
                              </span>
                            </td>
                            <td>
                              <input type="text" className="form-control border-light text-dark fw-bold wpx-150 py-2" value={item.response} readOnly />
                            </td>
                            <td>
                              <input type="text" className="form-control border-light text-dark fw-bold wpx-150 py-2" value={item.resolution} readOnly />
                            </td>
                            <td className="text-center">
                              <div className="d-flex align-items-center gap-2 justify-content-center">
                                <ActionIconButton label={t("edit")} icon={ACTION_ICONS.edit} variant="warning" />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* 3. Notification Settings Card */}
                <div className="card border-0 rounded-4 shadow-sm p-4 bg-white">
                  <h5 className="fw-bold text-dark mb-4">{t("notification_settings")}</h5>
                  
                  <div className="d-flex flex-column gap-0">
                    
                    {/* Item 1 */}
                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom border-light">
                      <div>
                        <div className="fw-bold text-dark text-14 mb-1">{t("new_work_request")}</div>
                        <div className="text-secondary text-12">{t("new_work_request_desc")}</div>
                      </div>
                      <input 
                        type="checkbox" 
                        className="form-check-input pointer" 
                        style={{ width: '20px', height: '20px' }}
                        checked={notify_new_request}
                        onChange={() => this.setState({ notify_new_request: !notify_new_request })}
                      />
                    </div>

                    {/* Item 2 */}
                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom border-light">
                      <div>
                        <div className="fw-bold text-dark text-14 mb-1">{t("sla_warning")}</div>
                        <div className="text-secondary text-12">{t("sla_warning_desc")}</div>
                      </div>
                      <input 
                        type="checkbox" 
                        className="form-check-input pointer" 
                        style={{ width: '20px', height: '20px' }}
                        checked={notify_sla_warning}
                        onChange={() => this.setState({ notify_sla_warning: !notify_sla_warning })}
                      />
                    </div>

                    {/* Item 3 */}
                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom border-light">
                      <div>
                        <div className="fw-bold text-dark text-14 mb-1">{t("job_completion")}</div>
                        <div className="text-secondary text-12">{t("job_completion_desc")}</div>
                      </div>
                      <input 
                        type="checkbox" 
                        className="form-check-input pointer" 
                        style={{ width: '20px', height: '20px' }}
                        checked={notify_job_completion}
                        onChange={() => this.setState({ notify_job_completion: !notify_job_completion })}
                      />
                    </div>

                    {/* Item 4 */}
                    <div className="d-flex justify-content-between align-items-center py-3">
                      <div>
                        <div className="fw-bold text-dark text-14 mb-1">{t("daily_summary")}</div>
                        <div className="text-secondary text-12">{t("daily_summary_desc")}</div>
                      </div>
                      <input 
                        type="checkbox" 
                        className="form-check-input pointer" 
                        style={{ width: '20px', height: '20px' }}
                        checked={notify_daily_summary}
                        onChange={() => this.setState({ notify_daily_summary: !notify_daily_summary })}
                      />
                    </div>

                  </div>
                </div>

                {/* Bottom Action Buttons */}
                <div className="d-flex justify-content-end gap-3 mt-2">
                  <button className="btn btn-white border px-4 py-2 rounded-3 text-dark fw-bold shadow-sm bg-white">
                    {t("cancel")}
                  </button>
                  <button className="btn btn-primary px-4 py-2 rounded-3 fw-bold d-flex align-items-center shadow-sm" style={{ backgroundColor: '#2563eb', borderColor: '#2563eb' }}>
                    <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                  </button>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}